/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import './style.scoped.scss';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import SignUpForm from '../../components/Account/SignUp';
import InfoLogin from '../../components/Account/SignUp/Info';
import ThankYou from '../../components/Account/SignUp/ThankYou';
import Resent from '../../components/Account/SignUp/Resent';
import RequestQuoteModal from '../../components/Modals/RequestQuoteModal';
import $ from 'jquery';
import ConfirmModal from '../../components/Modals/RequestQuoteModal/ConfirmModal';
import TsAndCs from '../../components/Account/Text';

const SignUp = () => {
  const [step, setStep] = useState(1);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1000);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [numberOfUsers, setNumberOfUsers] = useState(1);

  // using refs to ensure the load logic works
  const screenRef = useRef(isSmallScreen);
  screenRef.current = isSmallScreen;

  useEffect(() => {
    // listen for changes in window width for hide/show logic
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const checkScreenSize = () => {
    screenRef.current = window.innerWidth < 1000;
    setIsSmallScreen(screenRef.current);
  };

  const handleChange = (value) => {
    if (value > 10) {
      setNumberOfUsers(10);
      setShowQuoteModal(true);
    } else {
      setNumberOfUsers(value);
      setShowQuoteModal(false);
    }
  };

  const handleQuoteModal = () => {
    $('#requestQuoteModal').modal('show');
  };

  const handleSentSuccess = () => {
    $('#requestQuoteModal').modal('hide');
    $('#ConfirmModal').modal('show');
  };

  // step 1 - after form is filled and user is +properly validated, display thank you component
  // step 2 - user clicked on email link redirect user to login page

  return (
    <AccountPagesWrapper
      isRegister={step === 1 && !isSmallScreen ? true : false}
      noContainer
      signupForm={
        <React.Fragment>
          <SignUpForm
            handleUserJoined={() => setStep(2)}
            isSmallScreen={isSmallScreen}
            showQuoteModal={showQuoteModal}
            handleQuoteModal={handleQuoteModal}
            handleChange={handleChange}
            numberOfUsers={numberOfUsers}
          />
          <RequestQuoteModal
            handleClose={() => $('#requestQuoteModal').modal('hide')}
            handleDismiss={() => setShowQuoteModal(false)}
            handleSentSuccess={() => handleSentSuccess()}
          />
          <ConfirmModal />
        </React.Fragment>
      }
    >
      {step === 1 ? (
        isSmallScreen && (
          <React.Fragment>
            <div className='wf-account__cards'>
              {/* <InfoLogin isSmallScreen={isSmallScreen} /> */}
              <SignUpForm
                handleUserJoined={() => setStep(2)}
                isSmallScreen={isSmallScreen}
                showQuoteModal={showQuoteModal}
                handleQuoteModal={handleQuoteModal}
                handleChange={handleChange}
                numberOfUsers={numberOfUsers}
              />
              <RequestQuoteModal
                handleClose={() => $('#requestQuoteModal').modal('hide')}
                handleDismiss={() => setShowQuoteModal(false)}
                handleSentSuccess={handleSentSuccess}
              />
              <ConfirmModal />
              <div
                className='w-100'
                style={{
                  marginTop: '4rem',
                }}
              >
                <TsAndCs />
              </div>
            </div>
          </React.Fragment>
        )
      ) : step === 2 ? (
        <ThankYou resendUserEmail={() => setStep(3)} />
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '3rem',
          }}
        >
          <Resent />
        </div>
      )}
    </AccountPagesWrapper>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  plans: state.user.plans,
});

// const mapDispatchToProps = { getAvailablePlans };

export default connect(mapStateToProps, null)(SignUp);
